import { CHARACTER_ENTITY_TYPE_ID, ITEM_ENTITY_TYPE_ID, CAMPAIGN_ENTITY_TYPE_ID } from "../Core";
export var ContainerTypeEnum;
(function (ContainerTypeEnum) {
    ContainerTypeEnum[ContainerTypeEnum["CHARACTER"] = CHARACTER_ENTITY_TYPE_ID] = "CHARACTER";
    ContainerTypeEnum[ContainerTypeEnum["ITEM"] = ITEM_ENTITY_TYPE_ID] = "ITEM";
    ContainerTypeEnum[ContainerTypeEnum["CAMPAIGN"] = CAMPAIGN_ENTITY_TYPE_ID] = "CAMPAIGN";
})(ContainerTypeEnum || (ContainerTypeEnum = {}));
